import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../styles/PersonelProfil.css";
import "../styles/EgitimCard.css";
import MailboxPanel from "../components/MailboxPanel.js";
import EgitimStep from "./EgitimStep";
import EvrakPopup from "../pages/EvrakPopup.js";
import axios from "axios";

const egitimKartlari = [
  {
    id: 1,
    adi: "İSG Genel Konular",
    gorsel: "/images/isg.jpeg",
    aciklama: "İş sağlığı ve güvenliği temel modülleri",
    moduller: [
      { id: 1, ad: "Başlangıç", video: "/videos/0-1.mp4" },
      { id: 2, ad: "Tanım", video: "/videos/1-1.mp4" },
      { id: 3, ad: "Mevzuat", video: "/videos/1-2.mp4" },
      { id: 4, ad: "Hak ve Sorumluluklar", video: "/videos/1-3.mp4" },
      { id: 5, ad: "Düzen", video: "/videos/1-4.mp4" },
      { id: 6, ad: "Hukuki Sonuçlar", video: "/videos/1-5.mp4" },
    ],
  },
  {
    id: 2,
    adi: "İSG Sağlık Konuları",
    gorsel: "/images/isgsaglik.jpg",
    aciklama: "İş sağlığı ile ilgili konular",
    moduller: [
      { id: 1, ad: "Meslek Hastalıkları", video: "/videos/2-1.mp4" },
      { id: 2, ad: "Hastalıktan Korunma", video: "/videos/2-2.mp4" },
      { id: 3, ad: "Risk Etmenleri", video: "/videos/2-3.mp4" },
      { id: 4, ad: "İlk Yardım", video: "/videos/2-4.mp4" },
      { id: 5, ad: "Tütü Ürünleri", video: "/videos/2-5.mp4" },
    ],
  },
  {
    id: 3,
    adi: "İSG Teknik Konular",
    gorsel: "/images/isgtknık.jpeg",
    aciklama: "Bu kartın açıklaması",
    moduller: [
      { id: 1, ad: "Risk", video: "/videos/3-1.mp4" },
      { id: 2, ad: "Taşıma", video: "/videos/3-2.mp4" },
      { id: 3, ad: "Koruma", video: "/videos/3-3.mp4" },
      { id: 4, ad: "Kullanım", video: "/videos/3-4.mp4" },
      { id: 5, ad: "Çalışma", video: "/videos/3-5.mp4" },
      { id: 6, ad: "Önlemler", video: "/videos/3-6.mp4" },
      { id: 7, ad: "İşaretler", video: "/videos/3-7.mp4" },
      { id: 8, ad: "KKD", video: "/videos/3-8.mp4" },
      { id: 9, ad: "Tahliye", video: "/videos/3-9.mp4" },
    ],
  },
  {
    id: 4,
    adi: "İSG Güvenli Çalış",
    gorsel: "/images/sagliklicalis.jpeg",
    aciklama: "İş sağlığı ve güvenliği genel eğitimi",
    moduller: [{ id: 1, ad: "Genel Eğitim", video: "/videos/Guvenlicalis.mp4" }],
  },
  {
    id: 5,
    adi: "Kişisel Verilerin Korunması Kanunu",
    gorsel: "/images/kvkk.jpeg",
    aciklama: "İş sağlığı ve güvenliği genel eğitimi",
    moduller: [{ id: 1, ad: "Genel Eğitim", video: "/videos/kvkk.mp4" }],
  },
];

const PersonelProfil = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const modulTamamlandi = location.state?.modulTamamlandi;

  const [aktifMenu, setAktifMenu] = useState("egitimler");
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [sidebarPinned, setSidebarPinned] = useState(false);
  const [seciliEgitim, setSeciliEgitim] = useState(null);
  const [tamamlanmaDurumlari, setTamamlanmaDurumlari] = useState({});
  const [profilePhoto, setProfilePhoto] = useState(null);
  const [sertifikaFoto, setSertifikaFoto] = useState(null);
  const [buyukSertifika, setBuyukSertifika] = useState(null);
  const [showModul4Warning, setShowModul4Warning] = useState(false);
  const [modul4WarningMessage, setModul4WarningMessage] = useState("");
  const [showEvrakPopup, setShowEvrakPopup] = useState(false);
  const [sinavlar, setSinavlar] = useState([]);
  const [sinavlarLoading, setSinavlarLoading] = useState(false);
  const [sinavlarError, setSinavlarError] = useState("");
  const [seciliSinav, setSeciliSinav] = useState(null);
  const [showSinavBilgiPopup, setShowSinavBilgiPopup] = useState(false);

  const kullaniciAdi = localStorage.getItem("userName") || "Personel";
  const kullaniciMail = localStorage.getItem("userEmail") || "E-posta";
  const token = localStorage.getItem("token");
  const mailboxEmail = localStorage.getItem("mailboxEmail") || "";
  const mailSessionId = localStorage.getItem("mailSessionId") || "";

  useEffect(() => {
    const fetchSertifikaFoto = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/VerilenSertifika/benim-foto`,
          {
            headers: { Authorization: `Bearer ${token}` },
            responseType: "blob",
          }
        );

        const imgUrl = URL.createObjectURL(res.data);
        setSertifikaFoto(imgUrl);
      } catch (err) {
        console.error("Sertifika fotoğrafı alınamadı:", err);
        setSertifikaFoto(null);
      }
    };

    if (token) {
      fetchSertifikaFoto();
    }
  }, [token]);

  useEffect(() => {
    const fetchProfilePhoto = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/Auth/ppbak`,
          {
            headers: { Authorization: `Bearer ${token}` },
            responseType: "blob",
          }
        );
        const imgUrl = URL.createObjectURL(res.data);
        setProfilePhoto(imgUrl);
      } catch (err) {
        console.error("Profil fotoğrafı alınamadı:", err);
      }
    };
    if (token) fetchProfilePhoto();
  }, [token]);

  useEffect(() => {
    const fetchTamamlanmaDurumlari = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/Isg/modul-durumlarim`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        const list = res.data?.$values || res.data || [];
        const durumMap = {};

        list.forEach((item) => {
          if (item && typeof item.modul !== "undefined") {
            durumMap[item.modul] = item.basariDurumu === true;
          }
        });

        setTamamlanmaDurumlari(durumMap);
      } catch (err) {
        console.error("Modül durumları alınamadı:", err);
      }
    };

    if (token) fetchTamamlanmaDurumlari();
  }, [token]);

  useEffect(() => {
    if (modulTamamlandi) {
      setTamamlanmaDurumlari((prev) => ({
        ...prev,
        [modulTamamlandi]: true,
      }));
    }
  }, [modulTamamlandi]);

  useEffect(() => {
    if (token) {
      fetchSinavlar();
    }
  }, [token]);

  const fetchSinavlar = async () => {
    try {
      setSinavlarLoading(true);
      setSinavlarError("");

      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/KullaniciSinav/sinavlarim`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const liste = res.data?.$values || [];
      setSinavlar(liste);
    } catch (err) {
      console.error("Sınavlar alınamadı:", err);
      setSinavlar([]);
      setSinavlarError("Sınavlar yüklenirken hata oluştu.");
    } finally {
      setSinavlarLoading(false);
    }
  };

  const formatTarih = (tarih) => {
    if (!tarih) return "-";

    const parsed = new Date(tarih);

    if (Number.isNaN(parsed.getTime())) {
      return "-";
    }

    return parsed.toLocaleDateString("tr-TR");
  };

  const handleSinavPopupAc = (sinav) => {
    setSeciliSinav(sinav);
    setShowSinavBilgiPopup(true);
  };

  const handleSinavPopupKapat = () => {
    setShowSinavBilgiPopup(false);
    setSeciliSinav(null);
  };

  const handleSinavBaslat = async () => {
    if (!seciliSinav) return;

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/KullaniciSinav/baslat`,
        {
          sinavId: seciliSinav.sinavId,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const kullaniciSinavId =
        res.data?.kullaniciSinavId ||
        res.data?.id ||
        res.data?.data?.kullaniciSinavId;

      if (!kullaniciSinavId) {
        console.error("kullaniciSinavId bulunamadı:", res.data);
        return;
      }

      const soruIdleri = res.data?.randomSoruIcerikIdleri?.$values || [];

      const sinavState = {
        sinavBaslik: seciliSinav.baslik,
        sinavId: seciliSinav.sinavId,
        kullaniciSinavId,
        toplamSoru: res.data?.toplamSoru,
        kalanSureSaniye: res.data?.kalanSureSaniye,
        ilkSiraNo: res.data?.ilkSiraNo || 1,
        soruIdleri,
      };

      sessionStorage.setItem(
        `sinavState_${kullaniciSinavId}`,
        JSON.stringify(sinavState)
      );

      setShowSinavBilgiPopup(false);
      setSeciliSinav(null);

      navigate(`/personel/sinav/${kullaniciSinavId}`, {
        state: sinavState,
      });

    } catch (err) {
      console.error("Sınav başlatılamadı:", err);
    }
  };

  const getSinavKapakUrl = (kapakFotoUrl) => {
    if (!kapakFotoUrl) return null;

    if (kapakFotoUrl.startsWith("http://") || kapakFotoUrl.startsWith("https://")) {
      return kapakFotoUrl;
    }

    return `${process.env.REACT_APP_API_BASE_URL}${kapakFotoUrl}`;
  };

  const handleKatil = async (egitim) => {
    if (egitim.id === 4) {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/Isg/modul4-aktif-mi`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        const data = res.data;
        const aktif = data.modul4Aktif === true;

        if (!aktif) {
          const eksikIds =
            data.eksikModuller?.$values ||
            data.eksikModuller?.values ||
            data.eksikModuller ||
            [];

          let mesaj = "";

          if (Array.isArray(eksikIds) && eksikIds.length > 0) {
            const eksikAdlar = eksikIds
              .map((id) => {
                const kart = egitimKartlari.find((e) => e.id === id);
                return kart ? kart.adi : `Modül ${id}`;
              })
              .filter(Boolean);

            mesaj = `"${egitim.adi}" modülüne geçmeden önce şu eğitimleri tamamlamalısınız: ${eksikAdlar.join(
              ", "
            )}.`;
          } else {
            mesaj = `"${egitim.adi}" modülüne geçmeden önce önceki eğitimleri tamamlamalısınız.`;
          }

          setModul4WarningMessage(mesaj);
          setShowModul4Warning(true);
          return;
        }
      } catch (err) {
        console.error("modul4-aktif-mi kontrol hatası:", err);
      }
    }

    setSeciliEgitim(egitim);
  };

  const renderIcerik = () => {
    switch (aktifMenu) {
      case "egitimler":
        return (
          <div className="personel-icerik">
            <h2>Eğitimlerim</h2>
            <div className="egitim-card-list">
              {egitimKartlari.map((egitim) => {
                const tamamlandi = !!tamamlanmaDurumlari[egitim.id];
                const butonMetin = tamamlandi ? "Tamamlandı" : "Başla";

                return (
                  <div className="egitim-kart" key={egitim.id}>
                    <div className="egitim-kart-header">
                      <img
                        src={egitim.gorsel || "/images/default.jpg"}
                        alt="Eğitim Görsel"
                        className="egitim-kart-gorsel"
                      />
                    </div>
                    <div className="egitim-kart-alt">
                      <div className="egitim-logo">
                        <img src="/images/fulla.png" alt="Logo" />
                      </div>
                      <div className="egitim-baslik">{egitim.adi}</div>
                      <div className="egitim-butonu">
                        <button onClick={() => handleKatil(egitim)}>
                          {butonMetin}
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        );

      case "sertifikalar":
        return (
          <div className="personel-icerik">
            <h2>Sertifikalarım</h2>
            <div className="sertifika-kart-wrapper">
              {sertifikaFoto ? (
                <div
                  className="sertifika-kart sertifika-kucuk"
                  onClick={() => setBuyukSertifika(sertifikaFoto)}
                >
                  <img
                    src={sertifikaFoto}
                    alt="Sertifika"
                    className="sertifika-img"
                  />
                </div>
              ) : (
                <p className="sertifika-bos-mesaj">
                  Henüz tanımlı bir sertifikanız bulunmamaktadır.
                </p>
              )}
            </div>
          </div>
        );

      case "benim":
        return (
          <div className="personel-icerik">
            <h2>Benim Menüm</h2>

            <div className="benim-menu-grid">
              <button
                className="benim-menu-btn"
                onClick={() => setShowEvrakPopup(true)}
              >
                Evraklarım
              </button>
            </div>
          </div>
        );

      case "sinavlar":
        return (
          <div className="personel-icerik">
            <h2>Sınavlarım</h2>

            {sinavlarLoading && (
              <p className="sinav-bilgi-mesaji">Sınavlar yükleniyor...</p>
            )}

            {!sinavlarLoading && sinavlarError && (
              <p className="sinav-hata-mesaji">{sinavlarError}</p>
            )}

            {!sinavlarLoading && !sinavlarError && sinavlar.length === 0 && (
              <p className="sinav-bos-mesaj">
                Henüz size atanmış bir sınav bulunmamaktadır.
              </p>
            )}

            {!sinavlarLoading && !sinavlarError && sinavlar.length > 0 && (
              <div className="sinavlar-grid">
                {sinavlar.map((sinav) => (
                  <div className="egitim-kart sinav-egitim-kart" key={sinav.atamaId}>
                    <div className="egitim-kart-header">
                      {sinav.kapakFotoUrl ? (
                        <img
                          src={getSinavKapakUrl(sinav.kapakFotoUrl)}
                          alt={sinav.baslik}
                          className="egitim-kart-gorsel"
                          onError={(e) => {
                            e.currentTarget.style.display = "none";
                          }}
                        />
                      ) : (
                        <div className="sinav-kapak-placeholder">
                          <p>Eğitim görseli yok</p>
                        </div>
                      )}
                    </div>

                    <div className="egitim-kart-alt">
                      <div className="egitim-logo">
                        <img src="/images/fulla.png" alt="Logo" />
                      </div>

                      <div className="egitim-baslik sinav-egitim-baslik">
                        <span>{sinav.baslik}</span>

                        <div className="sinav-alt-bilgi">
                          <span className="sinav-mini-tarih">
                            Son Giriş Tarihi: {sinav.sonTarih ? formatTarih(sinav.sonTarih) : "-"}
                          </span>

                          <span
                            className={`sinav-mini-durum ${sinav.sonGectiMi === true
                              ? "gecti"
                              : sinav.sonGectiMi === false
                                ? "kaldi"
                                : "bekliyor"
                              }`}
                          >
                            {sinav.sonGectiMi === true
                              ? "Geçti"
                              : sinav.sonGectiMi === false
                                ? "Kaldı"
                                : "Hazır"}
                          </span>
                        </div>
                      </div>

                      <div className="egitim-butonu">
                        <button onClick={() => handleSinavPopupAc(sinav)}>
                          Sınava Başla
                        </button>
                      </div>
                    </div>
                  </div>

                ))}
              </div>
            )}
          </div>
        );

      case "mail":
        return (
          <div className="personel-icerik">
            {!mailSessionId ? (
              <p style={{ marginTop: 10 }}>
                Mail oturumu bulunamadı. (mailSessionId boş) <br />
                Login response mailbox verisi localStorage’a yazılıyor mu kontrol et.
              </p>
            ) : (
              <MailboxPanel
                sessionId={mailSessionId}
                mailboxEmail={mailboxEmail}
              />
            )}
          </div>
        );

      default:
        return <div className="personel-icerik">İçerik seçilmedi.</div>;
    }
  };

  return (
    <div className="personel-container">
      <div
        className={`personel-sidebar ${sidebarCollapsed ? "collapsed" : ""}`}
        onMouseEnter={() => {
          if (!sidebarPinned && sidebarCollapsed) {
            setSidebarCollapsed(false);
          }
        }}
        onMouseLeave={() => {
          if (!sidebarPinned) {
            setSidebarCollapsed(true);
          }
        }}
      >
        <button
          className="personel-sidebar-toggle"
          onClick={(e) => {
            e.stopPropagation();

            if (sidebarCollapsed) {
              setSidebarCollapsed(false);
              setSidebarPinned(true);
            } else {
              setSidebarPinned(false);
              setSidebarCollapsed(true);
            }
          }}
        >
          {sidebarCollapsed ? "›" : "‹"}
        </button>

        <div className="personel-user-info">
          <div className="personel-avatar">
            {profilePhoto ? (
              <img src={profilePhoto} alt="Profil" />
            ) : (
              <div className="navbar-user-photo-placeholder">👤</div>
            )}
          </div>
          <h3>{kullaniciAdi}</h3>
          <p>{kullaniciMail}</p>
        </div>

        <ul className="personel-menu">
          <li
            className={aktifMenu === "egitimler" ? "aktif" : ""}
            onClick={() => setAktifMenu("egitimler")}
          >
            <span className="personel-menu-icon">📘</span>
            <span className="personel-menu-text">Eğitimlerim</span>
          </li>

          <li
            className={aktifMenu === "sertifikalar" ? "aktif" : ""}
            onClick={() => setAktifMenu("sertifikalar")}
          >
            <span className="personel-menu-icon">🎓</span>
            <span className="personel-menu-text">Sertifikalarım</span>
          </li>

          <li
            className={aktifMenu === "videolar" ? "aktif" : ""}
            onClick={() => setAktifMenu("videolar")}
          >
            <span className="personel-menu-icon">🎥</span>
            <span className="personel-menu-text">Videolarım</span>
          </li>

          <li
            className={aktifMenu === "benim" ? "aktif" : ""}
            onClick={() => setAktifMenu("benim")}
          >
            <span className="personel-menu-icon">⭐</span>
            <span className="personel-menu-text">Benim Menüm</span>
          </li>

          <li
            className={aktifMenu === "sinavlar" ? "aktif" : ""}
            onClick={() => setAktifMenu("sinavlar")}
          >
            <span className="personel-menu-icon">📝</span>
            <span className="personel-menu-text">Sınavlarım</span>
          </li>

          <li
            className={aktifMenu === "mail" ? "aktif" : ""}
            onClick={() => setAktifMenu("mail")}
          >
            <span className="personel-menu-icon">✉️</span>
            <span className="personel-menu-text">Mail</span>
          </li>
        </ul>
      </div>

      <div className="personel-content">{renderIcerik()}</div>

      {seciliEgitim && (
        <div className="egitim-modal-overlay1">
          <div className="egitim-modal">
            <button
              className="modal-close"
              onClick={() => setSeciliEgitim(null)}
            >
              ✖
            </button>
            <EgitimStep
              egitim={seciliEgitim}
              onClose={() => setSeciliEgitim(null)}
            />
          </div>
        </div>
      )}

      {buyukSertifika && (
        <div
          className="sertifika-popup-overlay"
          onClick={() => setBuyukSertifika(null)}
        >
          <div className="sertifika-popup">
            <img src={buyukSertifika} alt="Sertifika Büyük" />
          </div>
        </div>
      )}

      {showModul4Warning && (
        <div className="modul-uyari-overlay">
          <div className="modul-uyari-popup">
            <p>{modul4WarningMessage}</p>
            <button onClick={() => setShowModul4Warning(false)}>Tamam</button>
          </div>
        </div>
      )}

      {showEvrakPopup && (
        <EvrakPopup onClose={() => setShowEvrakPopup(false)} />
      )}

      {showSinavBilgiPopup && seciliSinav && (
        <div className="sinav-popup-overlay">
          <div className="sinav-popup">
            <button
              className="sinav-popup-close"
              onClick={handleSinavPopupKapat}
            >
              ×
            </button>

            <h2 className="sinav-popup-title">{seciliSinav.baslik}</h2>

            {seciliSinav.aciklama && (
              <p className="sinav-popup-desc">{seciliSinav.aciklama}</p>
            )}

            <div className="sinav-popup-info-grid">
              <div className="sinav-popup-info">
                <span>Süre</span>
                <strong>{seciliSinav.sureDakika} dk</strong>
              </div>

              <div className="sinav-popup-info">
                <span>Geçme Notu</span>
                <strong>{seciliSinav.gecmePuani}</strong>
              </div>

              <div className="sinav-popup-info">
                <span>Kalan Hak</span>
                <strong>{seciliSinav.kalanGirisHakki}</strong>
              </div>

              <div className="sinav-popup-info">
                <span>Son Tarih</span>
                <strong>{formatTarih(seciliSinav.sonTarih)}</strong>
              </div>
            </div>

            <div className="sinav-popup-rules">
              <h3>Sınav Kuralları</h3>

              <ul>
                <li>Sınav başladıktan sonra süre işlemeye başlar.</li>

                <li>Her soru için yalnızca bir cevap seçebilirsiniz.</li>

                <li>İşaretlediğiniz sorular sol taraftaki soru panelinde yeşil
                  olarak gösterilecektir.</li>

                <li>Sorular arasında geçiş yapabilirsiniz ancak süre işlemeye devam eder.</li>

                <li>Tarayıcıyı kapatmanız, sayfadan çıkmanız veya geri gitmeniz
                  durumunda sınavınız geçersiz sayılabilir.</li>

                <li>Süre dolduğunda sınav otomatik olarak tamamlanacaktır.</li>

                <li>Sınavı tamamladıktan sonra sonuç ekranınız otomatik olarak gösterilecektir.</li>

                <li>Geçme puanının altında sonuç almanız durumunda, kalan giriş hakkınız
                  varsa tekrar sınava katılım sağlayabilirsiniz.</li>

                <li>Kalan giriş hakkınız dolduğunda sınava tekrar erişim sağlayamayabilirsiniz.</li>
              </ul>
            </div>
            <div className="sinav-popup-actions">
              <button
                className="sinav-popup-cancel"
                onClick={handleSinavPopupKapat}
              >
                Vazgeç
              </button>

              <button
                className="sinav-popup-start"
                onClick={handleSinavBaslat}
              >
                Anladım
              </button>

            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PersonelProfil;